module.exports = __webpack_public_path__ + "follow.88fd4a75.png";